module.exports = __webpack_public_path__ + "assets/img/chop.eed51992.png";